const arrondissementTypes = {
    SAVE_ARRONDISSEMENT: 'SAVE_ARRONDISSEMENT',
    GET_ARRONDISSEMENTS: 'GET_ARRONDISSEMENTS',
    SET_ARRONDISSEMENTS: 'SET_ARRONDISSEMENTS',
    UPDATE_ARRONDISSEMENT: 'UPDATE_ARRONDISSEMENT',
    DELETE_ARRONDISSEMENT: 'DELETE_ARRONDISSEMENT'
};

export default arrondissementTypes;
